import Navbar from './components/Navbar';
import Hero from './components/Hero';
import AboutStory from './components/AboutStory';
import FeaturedPublications from './components/FeaturedPublications';
import LatestContent from './components/LatestContent';
import Testimonial from './components/Testimonial';
import CTASection from './components/CTASection';
import Footer from './components/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen">
      <Navbar />
      <main>
        <Hero />
        <AboutStory />
        <FeaturedPublications />
        <LatestContent />
        <Testimonial />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}
